<template>
  <div>
    <vs-alert class="mt-2">
      <p>Complete este formulario solo si el pago a la escuela se realizó en varias transacciones. Estos valores no suman al pago principal.
        Registre cada monto y detalle correspondiente.</p>
    </vs-alert>
    <p class="mt-2 text-2xl">
      <b>Total Detalle:</b> {{ totalValor }}
    </p>
    <div class="mt-5">
      <vs-button icon="add" class="mb-2 p-3" @click="f_limpiar();title='Agregar detalle de pago';popupAdd=true;">Crear</vs-button>
    </div>
    <vs-table max-items="5" search pagination :data="arrayDetallesPagos">
      <template slot="header">
          <vs-chip  color="primary">Cantidad: <b> {{ arrayDetallesPagos.length }}</b></vs-chip>
      </template>
      <template slot="thead">
          <vs-th>Valor</vs-th>
          <vs-th>Descripción</vs-th>
          <vs-th>Acciones</vs-th>
      </template>
      <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                  <div class="mb-2">
                    <b>Total:</b> <span class="text-primary" style="font-size: 18px; font-weight: 700;">${{ Number(tr.total).toFixed(2) }}</span>
                  </div>
                  <p><b>Subtotal:</b> ${{ Number(tr.subtotal).toFixed(2) }}</p>
                  <p><b>IVA:</b> ${{ Number(tr.iva_valor).toFixed(2) }}</p>
                  <p><b>Retención:</b> ${{ Number(tr.retencion).toFixed(2) }}</p>
                  <vs-divider class="my-2"></vs-divider>
                  <div v-if="tr.documento_dni" class="mt-2">
                    <b>{{ tr.tipo_identificacion == 'RUC' ? 'RUC' : 'Cédula' }}:</b>
                    <p>{{ tr.documento_dni }}</p>
                  </div>
                  <div v-if="tr.razon_social" class="mt-2">
                    <b>Razón Social:</b>
                    <p>{{ tr.razon_social }}</p>
                  </div>
                  <b class="mt-2">Fecha creación:</b>
                  <p>{{ tr.created_at }}</p>
                  <b>Creador:</b>
                  <p>{{ tr.usuario_creador }}</p>
                  <b v-if="tr.usuario_editor">Último Editor:</b>
                  <p v-if="tr.usuario_editor">{{ tr.usuario_editor }}</p>
              </vs-td>
              <vs-td>
                  {{data[indextr].descripcion}}<br>
              </vs-td>
              <vs-td align="center">
                <!--boton editar-->
                <vs-button class="m-2" size="small" @click="DetalleSelected=tr;f_preEditar();" icon-pack="feather" icon="icon-edit">Editar</vs-button>
                <!--boton eliminar-->
                <vs-button class="m-2" size="small" color="danger" @click="DetalleSelected=tr;popupConfirmDelete=true;" type="filled" icon-pack="feather" icon="icon-x-square"> Eliminar</vs-button>
              </vs-td>
          </vs-tr>
      </template>
    </vs-table>
    <!--modal para crear detalle pago-->
    <vs-popup classContent="popup-example" fullscreen :title="title" :active.sync="popupAdd" class="informacionformhijo">
      <div v-if="popupAdd">
        <div class="flex flex-wrap -mx-2">
          <!-- Tipo de identificación -->
          <div class="w-full px-2 mb-3">
            <ul class="flex" style="flex-wrap: wrap;">
              <li class="mr-5">Identificación:</li>
              <li class="mr-3">
                <vs-radio v-model="datos.tipo_identificacion" @input="f_limpiarUsuario" vs-name="radios1" vs-value="CI">Cédula</vs-radio>
              </li>
              <li class="mr-3">
                <vs-radio v-model="datos.tipo_identificacion" @input="f_limpiarUsuario" vs-name="radios1" vs-value="RUC">RUC</vs-radio>
              </li>
            </ul>
            <div class="mt-3">
              <busquedaCedulaVue v-if="datos.tipo_identificacion == 'CI'" @f_changeUsuario="f_changeUsuario" @f_limpiarUsuario="f_limpiarUsuario" @f_setearNuevoUser="f_setearNuevoUser"/>
              <busquedaRucVue v-if="datos.tipo_identificacion == 'RUC'" @f_changeUsuario="f_changeUsuario" @f_limpiarUsuario="f_limpiarUsuario" @f_setearNuevoUser="f_setearNuevoUser"/>
            </div>
          </div>

          <!-- Documento (RUC/Cédula) -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>{{ datos.tipo_identificacion == 'RUC' ? 'RUC' : 'Cédula' }}:</small>
            <vs-input v-model="datos.documento_dni" class="w-full" :disabled="true"></vs-input>
          </div>

          <!-- Razón Social -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>Razón Social:</small>
            <vs-input v-model="datos.razon_social" class="w-full"></vs-input>
          </div>

          <!-- Subtotal -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>Subtotal: <span class="text-danger">*</span></small>
            <vs-input v-model="datos.subtotal" class="w-full" @input="calcularTotal"></vs-input>
          </div>

          <!-- IVA -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>IVA:</small>
            <vs-input v-model="datos.iva_valor" class="w-full" @input="calcularTotal"></vs-input>
          </div>

          <!-- Retención -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>Retención:</small>
            <vs-input v-model="datos.retencion" class="w-full"></vs-input>
          </div>

          <!-- Total (calculado) -->
          <div class="w-full md:w-1/2 px-2 mt-3">
            <small>Total: <span class="text-danger">*</span></small>
            <vs-input v-model="datos.total" class="w-full"></vs-input>
          </div>

          <!-- Descripción -->
          <div class="w-full px-2 mt-3">
            <small>Observación:</small>
            <vs-textarea counter="500" :counter-danger.sync="counterDanger" height="200px" label="Observación" v-model="datos.descripcion" />
          </div>
        </div>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_guardarDetalle()" class="m-2" icon="check">Guardar</vs-button>
          <vs-button @click="popupAdd=false" type="border"  color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
    <!--MODAL PARA CONFIRM ELIMINAR-->
    <vs-popup classContent="popup-example" title="Eliminar" :active.sync="popupConfirmDelete" class="informacionformhijo">
      <div v-if="popupConfirmDelete">
        <p class="text-center font-bold text-2xl">Estas seguro de eliminar?</p>
        <div class="flex justify-center mt-5">
          <vs-button @click="f_eliminarDetalle()" class="m-2" icon="check">Si, deseo eliminar</vs-button>
          <vs-button @click="popupConfirmDelete=false" type="border"  color="warning" class="m-2" icon="close">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Generalmix from '../../../../../../mixins/Generalmix'

const busquedaCedulaVue = () => import('../../../../../pedidos/busquedaCedula.vue')
const busquedaRucVue    = () => import('../../../../../pedidos/busquedaRuc.vue')

export default{
  mixins:[Generalmix],
  components: {
    busquedaCedulaVue,
    busquedaRucVue,
  },
  data(){
    return{
      usuario:[],
      arrayDetallesPagos: [],
      popupAdd: false,
      popupConfirmDelete: false,
      id: 0,
      datos:{
        tipo_identificacion: 'CI',
        documento_dni: '',
        razon_social: '',
        subtotal: 0,
        iva_valor: 0,
        retencion: 0,
        total: 0,
        descripcion: '',
      },
      DetalleSelected:'',
      title:'Agregar detalle de pago',
      counterDanger: false,
      ifCrearBeneficiario: false,
    }
  },
  props:{
    id_pago:{
      type: Number,
      default: 0
    },
  },
  mounted(){
    let me = this
    me.usuario = JSON.parse(localStorage.getItem('usuario'))
    me.f_getDetallesPago()
  },
  computed:{
    totalValor(){
      let me = this
      let total = 0
      if(me.arrayDetallesPagos.length > 0){
        me.arrayDetallesPagos.forEach(function (item) {
          total += parseFloat(item.total || 0)
        })
      }
      return total.toFixed(2)
    },
  },
  methods:{
    limpiarValorNumerico(valor) {
      let limpio = String(valor).replace(/[^0-9.]/g, '')
      const partes = limpio.split('.')
      if (partes.length > 2) {
        limpio = partes[0] + '.' + partes.slice(1).join('')
      }
      if (limpio.includes('.')) {
        const [entero, decimal] = limpio.split('.')
        if (entero.length > 6) {
          limpio = entero.substring(0, 6) + '.' + decimal
        }
      } else {
        if (limpio.length > 6) {
          limpio = limpio.substring(0, 6)
        }
      }
      return limpio
    },
    calcularTotal() {
      this.datos.subtotal = this.limpiarValorNumerico(this.datos.subtotal)
      this.datos.iva_valor = this.limpiarValorNumerico(this.datos.iva_valor)
      this.datos.retencion = this.limpiarValorNumerico(this.datos.retencion)

      const subtotal = parseFloat(this.datos.subtotal) || 0
      const iva = parseFloat(this.datos.iva_valor) || 0

      this.datos.total = (subtotal + iva).toFixed(2)
    },
    f_changeUsuario(e) {
      let me = this
      let dataUser = e.user
      if (dataUser) {
        me.ifCrearBeneficiario = false
        me.datos.documento_dni = dataUser.cedula
        me.datos.razon_social = `${dataUser.nombres} ${dataUser.apellidos}`
      } else {
        me.ifCrearBeneficiario = true
      }
    },
    f_limpiarUsuario() {
      let me = this
      me.ifCrearBeneficiario = false
      me.datos.documento_dni = ''
      me.datos.razon_social = ''
    },
    f_setearNuevoUser(e) {
      let me = this
      me.ifCrearBeneficiario = false
      me.datos.documento_dni = e.documento
      me.datos.razon_social = `${e.nombres} ${e.apellidos}`
    },
    validarValor(event) {
      let valor = event;
      if (/[^0-9.]/.test(valor)) {
        this.datos.subtotal = "0";
      } else {
        this.datos.subtotal = valor;
      }
    },
    f_getDetallesPago(){
      let me = this
      me.arrayDetallesPagos = []
      me.$http.get(me.$server_url + `pedigo_Pagos?getSubPagos=1&doc_codigo=${ me.id_pago }`)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'error')
          return
        }
        if(res.data.length == 0){
          me.m_message('No hay detalles de pagos para mostrar','warning')
          return
        }
        me.arrayDetallesPagos = res.data
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    f_preEditar(){
      let me = this
      me.id                       = me.DetalleSelected.id_pedido_pago_detalle
      me.datos.tipo_identificacion = me.DetalleSelected.tipo_identificacion || 'CI'
      me.datos.documento_dni      = me.DetalleSelected.documento_dni
      me.datos.razon_social       = me.DetalleSelected.razon_social
      me.datos.subtotal           = me.DetalleSelected.subtotal
      me.datos.iva_valor          = me.DetalleSelected.iva_valor
      me.datos.retencion          = me.DetalleSelected.retencion
      me.datos.total              = me.DetalleSelected.total
      me.datos.descripcion        = me.DetalleSelected.descripcion
      me.title                    = 'Editar detalle de pago'
      me.popupAdd                 = true
    },
    f_guardarDetalle(){
      let me = this
      if (Number(me.datos.subtotal) <= 0) {
        me.m_message('El subtotal debe ser mayor a 0','warning')
        return
      }
      if (Number(me.datos.total) <= 0) {
        me.m_message('El total debe ser mayor a 0','warning')
        return
      }
      me.datos.descripcion = me.datos.descripcion.trim()
      if(me.datos.descripcion == ''){
        me.m_message('La descripción no puede estar vacía','warning')
        return
      }
      if(me.datos.descripcion.length > 500){
        me.m_message('La descripción no puede tener más de 500 caracteres','warning')
        return
      }
      let formData = new FormData()
      formData.append('saveDetallePago', 1)
      formData.append('id', me.id)
      formData.append('id_usuario',          me.usuario.idusuario)
      formData.append('id_pago',             me.id_pago)
      formData.append('tipo_identificacion', me.datos.tipo_identificacion)
      formData.append('documento_dni',       me.datos.documento_dni || '')
      formData.append('razon_social',        me.datos.razon_social)
      formData.append('subtotal',            me.datos.subtotal)
      formData.append('iva_valor',           me.datos.iva_valor)
      formData.append('retencion',           me.datos.retencion || 0)
      formData.append('total',               me.datos.total)
      formData.append('descripcion',         me.datos.descripcion)
      me.$http.post(me.$server_url + `pedigo_Pagos`, formData)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'warning')
          return
        }
        me.popupAdd = false
        me.f_getDetallesPago()
        me.m_message(me.id > 0 ? 'Detalle actualizado con éxito' : 'Detalle creado con éxito','success')
        me.f_limpiar()
      })
      .catch(function (error) {
        me.popupAdd = false
        me.m_message('Error al guardar el detalle de pago','warning')
        console.log(error);
      });
    },
    f_eliminarDetalle(){
      let me = this
      let formData = new FormData()
      formData.append('eliminarDetallePago', 1)
      formData.append('id', me.DetalleSelected.id_pedido_pago_detalle)
      formData.append('id_usuario', me.usuario.idusuario)
      me.$http.post(me.$server_url + `pedigo_Pagos`, formData)
      .then(function (res) {
        if(res.data.status == 0){
          me.m_message(res.data.message,'warning')
          return
        }
        me.popupConfirmDelete = false
        me.f_getDetallesPago()
        me.m_message('Detalle de pago eliminado con éxito','success')
      })
      .catch(function (error) {
        me.popupConfirmDelete = false
        me.m_message('Error al eliminar el detalle de pago','warning')
        console.log(error);
      });
    },
    f_limpiar(){
      let me = this
      me.id = 0
      me.datos.tipo_identificacion = 'CI'
      me.datos.documento_dni = ''
      me.datos.razon_social = ''
      me.datos.subtotal = 0
      me.datos.iva_valor = 0
      me.datos.retencion = 0
      me.datos.total = 0
      me.datos.descripcion = ''
      me.ifCrearBeneficiario = false
    }
  },
}
</script>
<style scoped>
.informacionformhijo {
    z-index: 51002;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */
}
</style>

